<template>
    <section id="businessThankYouSreen">
        <div class="container">
            <div class="logo">
                <img :src="`${publicPath}img/shaves_logo.svg`" alt>
            </div>

            <div v-if="isDownloadFile" class="textCopy">
                <h4>Shaves Digital Loyalty card</h4>
                <h2 style="line-height: 1em;">Download your card</h2>
                <p class="primary">We've made it even simpler to get great discounts & benefits.</p>
                <button @click="download" class="button is-white">
                    Download
                </button>
            </div>

            <div v-else class="textCopy">
                <h4>Shaves Digital Loyalty card</h4>
                <h2>Add to your wallet</h2>
                <p class="primary">We've made it even simpler to get great discounts & benefits.</p>
                
                <div class="goback">
                    <button @click="back()" class="button is-white">
                        <i class="fas fa-chevron-left"></i>
                    </button>
                    Scan to add to {{ qrType }} Wallet
                </div>
                
                <div class="qr-container">
                    <QrcodeVue class="qr-code" :value="url" :size="qrSize" level="H" />
                </div>
                <p v-if="!fromEmail">This registration will close & clear all information in {{ secondsRemaining }} seconds</p>
            </div>

        </div>
    </section>
</template>

<script>
export default {
    name: "DigitalWalletQr",
    data() {
        return {
            publicPath: process.env.BASE_URL,
            secondsRemaining: 60,
            qrSize: 300,
            downloadButton: null,
            timer: null
        };
    },
    computed: {
        // Visitors from the welcome emails are on their own device, not the in-store kiosk
        fromEmail() {
            return this.$route.query.source === 'welcome-email';
        },
        // true if query param is present
        isDownloadFile() {
            return this.$route.query.file;
        },
        // unified computed for the url
        qrType() {
            const card = this.$store.state.loyaltyCard.data;
            if (card && card.message && card.message.includes('Apple')) {
                return 'Apple'
            } else {
                return 'Google'
            }
        },
        url() {
            const card = this.$store.state.loyaltyCard.data;
            if (!card) return '';
            if (card.message && card.message.includes('Apple')) {
                // return `${this.$store.state.apiBaseUrl}/apple-loyalty-card/${card.wallet_url}`;
                return `${window.origin}/digital-loyalty-scan?file=${card.wallet_url}`;
            } else {
                return card.wallet_url
            }
        },
    },
    mounted() {
        if (this.isDownloadFile) {
            this.downloadButton = `${this.$store.state.apiBaseUrl}/apple-loyalty-card/${this.$route.query.file}`
        } else if (!this.fromEmail) {
            this.timer = setInterval(() => {
                this.secondsRemaining -= 1;
                if (this.secondsRemaining == 0) {
                    this.$router.push("/");
                }
            }, 1000);
        }

    },
    created() {
        this.updateSize()
        window.addEventListener('resize', this.updateSize)
    },
    beforeDestroy() {
        clearInterval(this.timer)
        window.removeEventListener('resize', this.updateSize)
    },
    methods: {
        download() {
            // Same tab: new tabs/popups get blocked, and Safari shows the Add to Apple Wallet sheet for the .pkpass
            window.location.href = this.downloadButton;
        },
        back() {
            this.$router.go(-1);
        },
        updateSize() {
            const width = window.innerWidth
            this.qrSize = width < 600 ? 150 : 300
        },
    },
};
</script>
